<ion-card
  button="true"
  (click)="showFastpayInfoModal()"
>
  <ion-card-header mode="ios">
    <ion-card-title color="white">
      {{ 'fast_pay.request_fast_pay_cta' | translate }}
    </ion-card-title>
    <ion-card-subtitle color="white">
      {{ 'fast_pay.get_fast_pay_cta' | translate }}
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content class="ion-text-end">
    <ion-button color="white">{{ 'fast_pay.view_conditions' | translate }}</ion-button>
  </ion-card-content>
</ion-card>
